import { connect } from "react-redux";

import { MODAL_TYPES } from "../constants/modals";
import * as actions from "../constants/actions";
import AccountIndex from "../components/account/Index";
import { withTranslation } from "react-i18next";

const mapStateToProps = state => {
  const modelsByFolderId = state.models.allIds.reduce((acc, id) => {
    const { folderId } = state.models.byIds[id];

    acc[folderId] = acc[folderId] || [];
    acc[folderId].push(state.models.byIds[id]);

    return acc;
  }, {});

  return {
    lng: state.locale.lng,
    userFullname: `${state.user.firstname} ${state.user.lastname}`,
    userCompany: state.user.company,
    folders: state.folders,
    modelsByFolderId
  };
};

const mapDispatchToProps = dispatch => ({
  deleteModel: payload => dispatch(actions.deleteModel(payload)),
  deleteFolder: payload => dispatch(actions.deleteFolder(payload)),
  openCreateFolderModal: () =>
    dispatch(actions.openModal({ modalType: MODAL_TYPES.CREATE_FOLDER })),
  openDeleteModelConfirmationModal: () =>
    dispatch(
      actions.openModal({ modalType: MODAL_TYPES.DELETE_MODEL_CONFIRMATION })
    ),
  openDownloadFolderModal: modalProps =>
    dispatch(
      actions.openModal({ modalType: MODAL_TYPES.DOWNLOAD_FOLDER, modalProps })
    ),
  openShareModelModal: id =>
    dispatch(
      actions.openModal({
        modalType: MODAL_TYPES.SHARE_MODEL,
        modalProps: { id }
      })
    ),
  openUpdateFolderModal: id =>
    dispatch(
      actions.openModal({
        modalType: MODAL_TYPES.UPDATE_FOLDER,
        modalProps: { id }
      })
    ),
  clearModelExport: () => dispatch(actions.clearModelExport())
});

const connectedComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountIndex);
const withTranslationComponent = withTranslation(["footer", "common"])(connectedComponent);

export default withTranslationComponent;



// WEBPACK FOOTER //
// ./src/containers/AccountIndex.js